import { GET_ENTITY_SEARCH, RESET_ENTITY_SEARCH } from "../types/entitySearchType";

const initialState = {
    entityData: {}
};

const entitySearchReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_ENTITY_SEARCH:
            return {
                ...state,
                entityData: payload
            };
        case RESET_ENTITY_SEARCH:
            return {
                ...state,
                entityData: {}
            };
        default:
            return state;
    }
};

export default entitySearchReducer;
